import { createFileRoute } from "@tanstack/react-router";

import textLogo from "@/assets/images/text.png";
import { m } from "@/paraglide/messages.js";

const LAST_UPDATED = "September 7, 2026";

const SECTIONS = [
  {
    title: "Overview",
    body: "This site is the personal portfolio of Maciej Pyrc. It presents my open source libraries and products and offers an email newsletter. By using the site or subscribing to the newsletter you agree to these terms.",
  },
  {
    title: "No accounts",
    body: "The site has no user accounts, no paid features, and no trials. Nothing here asks you for a password or payment details. The only thing you can sign up for is the newsletter, which needs an email address and nothing else.",
  },
  {
    title: "Newsletter",
    body: "The newsletter is free. Subscribing means you agree to receive occasional emails about my projects, releases, and how I build them. You can stop them at any time with the unsubscribe link in every issue. How your address is handled is described in the Privacy Policy.",
  },
  {
    title: "Content and links",
    body: "Articles, newsletter issues, and other content on this site are my own opinions and are provided for information only. Links to other sites are provided for convenience. I do not control those sites and am not responsible for their content.",
  },
  {
    title: "Open source and intellectual property",
    body: "The open source libraries shown here are licensed under the terms published in their own repositories, which apply instead of these terms. Everything else on this site, including text, design, and images, belongs to me unless stated otherwise, and may not be reused commercially without permission.",
  },
  {
    title: "Availability and liability",
    body: "The site and the newsletter are provided as they are, without any warranty. I may change, pause, or shut down either of them at any time. To the extent permitted by law, I am not liable for any loss arising from your use of the site or from reliance on its content.",
  },
  {
    title: "Changes",
    body: "These terms may be updated from time to time. The date at the top shows the current version. Continuing to use the site or stay subscribed after a change means you accept the updated terms.",
  },
  {
    title: "Governing law and contact",
    body: "These terms are governed by the laws of Poland. Questions about them can be sent by replying to any newsletter issue or through the links on the homepage.",
  },
] as const;

export const Route = createFileRoute("/(public)/terms/")({
  component: TermsPage,
  loader: () => ({
    crumb: m.auth_terms_crumb(),
  }),
});

function TermsPage() {
  return (
    <div className="min-h-svh px-6 py-10 md:px-10">
      <div className="mx-auto w-full max-w-2xl">
        <a href="/" className="mb-10 inline-flex items-center gap-2 font-medium">
          <img src={textLogo} alt={m.app_title()} className="h-12 dark:invert" />
        </a>

        <div className="space-y-1">
          <h1 className="text-3xl font-bold tracking-tight">{m.auth_legal_terms()}</h1>
          <p className="text-sm text-muted-foreground">{m.auth_legal_last_updated({ date: LAST_UPDATED })}</p>
        </div>

        <div className="mt-10 space-y-8">
          {SECTIONS.map((section, index) => (
            <section key={section.title}>
              <h2 className="text-lg font-semibold">
                {index + 1}. {section.title}
              </h2>
              <p className="mt-2 text-sm leading-relaxed text-muted-foreground">{section.body}</p>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}
